"use client"

import { usePathname } from 'next/navigation';
import dynamic from 'next/dynamic';

// Bgコンポーネントを動的インポートで安全に読み込み
const Bg = dynamic(() => import('@/components/layout/Bg'), {
  ssr: false,
  loading: () => null,
});

function ConditionalBg() {
  const pathname = usePathname();
  
  // ログイン関連のページでは背景コンポーネントを非表示
  const isLoginPage = pathname.startsWith('/login');
  
  if (isLoginPage) {
    return null;
  }
  
  return <Bg />;
}

export default ConditionalBg; 